import tw from 'tailwind-styled-components';

export default tw.div`
  max-w-7xl
  mx-auto
  w-full
`;
